<template>

        <div class="hoverable search-form  p-3 m-0" style="background-color: #00000080; color:white">
            <form class="search-form-vertical" action="/#/search" method="get">
                <div>
                    <!-- Default inline 1-->
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" name="flight_type" class="custom-control-input" id="gidisDonus"  value="RT" @click="dateRange = 'range'" v-model="flightType">
                        <label class="custom-control-label" for="gidisDonus">Gidiş - Dönüş</label>
                    </div>

                    <!-- Default inline 2-->
                    <div class="custom-control custom-radio custom-control-inline">
                        <input type="radio" name="flight_type" class="custom-control-input" id="tekYon" checked value="OW" @click="dateRange = 'single'" v-model="flightType">
                        <label class="custom-control-label" for="tekYon">Tek yön</label>
                    </div>

                    <div class="custom-control custom-checkbox custom-control-inline">
                        <input type="checkbox" name="if_direct_flight_only" class="custom-control-input" id="defaultInline3" value="1" v-model="if_direct_flight_only">
                        <label class="custom-control-label" for="defaultInline3">Direkt uçuşları göster</label>
                    </div>


                </div>
                <div class="row">

                    <div class="col-10 col-md-2 pr-md-0">
                        <AirbnbStyleDatepicker v-if="dateRange === 'range'"
                                               :key="1"
                                               :trigger-element-id="'datepicker-trigger'"
                                               :mode="'range'"
                                               :fullscreen-mobile="true"
                                               :min-date=callFunction()
                                               :date-one="dateOne"
                                               :date-two="dateTwo"
                                               @date-one-selected="val => { dateOne = val }"
                                               @date-two-selected="val => { dateTwo = val }"
                        />
                        <AirbnbStyleDatepicker v-if="dateRange === 'single'"
                                               :key="2"
                                               :trigger-element-id="'datepicker-trigger'"
                                               :mode="'single'"
                                               :fullscreen-mobile="true"
                                               :min-date="callFunction()"
                                               :date-one="dateOne"
                                               @date-one-selected="val => { dateOne = val }"
                                               @date-two-selected="val => { dateTwo = val }"
                        />
                        <mdb-input outline  label="Kalkış Yeri" v-model="fromString" v-on:input="fromFly"
                                   ref="frominput" @click="selectFromText" class="sr-input"
                        >
                        <img src="../assets/images/Kalkis.png" class="input-icon">
                        </mdb-input>

                        <input type="hidden" id="from" class="form-control" v-model="fromAirCode" name="from" />
                        <input type="hidden" id="fromCity" class="form-control" v-model="fromCity" name="fromCityName" />
                        <input type="hidden" id="fromName" class="form-control" v-model="fromName" name="fromName" />
                        <input type="hidden" id="fromCountry" class="form-control" v-model="fromCountry" name="fromCountry" />
                        <input type="hidden" id="fromIsCity" class="form-control" v-model="fromIsCity" name="fromIsCity" />

                        <ul id="autocomplete-result-list-0" role="listbox" class="autocomplete-result-list"
                            v-if="fromAutoComplate"
                            style="position: absolute; z-index: 100; width: 200%; visibility: visible;  top: 100%;">

                            <li :id="'autocomplete-result-'+index" :data-result-index="index" role="option"
                                v-on:click="selectAir('from')"
                                class="autocomplete-result text-muted" v-for="(airport, index) in airports" :key="index"
                                :data-airport-code="airport.code"
                                :data-airport-city="airport.city_name!=null?airport.city_name:airport.label.split('-')[1]"
                                :data-airport-name="airport.value"
                                :data-airport-country="airport.label"
                                :data-country="airport.country_code"
                                :data-iscity="airport.is_city"
                            >{{airport.code + " - " + airport.label}}</li>
                        </ul>

                    </div>
                    <div class="change-icon">
                        <span @click="changeToRouth"><img src="../assets/images/exchange-icon.png" style="width:24px;cursor: pointer" /></span>
                    </div>
                    <div class="col-12 col-md-2 pl-md-0">
                        <mdb-input  v-model="toString" v-on:input="toFly" class="sr-input"
                               label="Varış Yeri" outline ref="toinput" @click="selectToText"
                        >
                        <img src="../assets/images/inis.png" class="input-icon">
                        </mdb-input>

                        <input type="hidden" id="to" class="form-control" v-model="toAirCode" name="to" />
                        <input type="hidden" id="toCityName" class="form-control" v-model="toCity" name="toCityName" />
                        <input type="hidden" id="toName" class="form-control" v-model="toName" name="toName" />
                        <input type="hidden" id="toCountry" class="form-control" v-model="toCountry" name="toCountry" />
                        <input type="hidden" id="toIsCity" class="form-control" v-model="toIsCity" name="toIsCity" />

                        <ul id="autocomplete-result-list-1" role="listbox" class="autocomplete-result-list"
                            v-if="toAutoComplate"
                            style="position: absolute; z-index: 100; width: 200%; visibility: visible;  top: 100%;">

                            <li :id="'autocomplete-result-'+index" :data-result-index="index" role="option"
                                v-on:click="selectAir('to')"
                                class="autocomplete-result text-muted" v-for="(airport, index) in airports" :key="index"
                                :data-airport-code="airport.code"
                                :data-airport-city="airport.city_name!=null?airport.city_name:airport.label.split('-')[1]"
                                :data-airport-name="airport.value"
                                :data-airport-country="airport.label"
                                :data-country="airport.country_code"
                                :data-iscity="airport.is_city"
                            >{{airport.code + " - " + airport.label}}</li>
                        </ul>

                    </div>
                    <div class="col-12 col-md-2 pl-md-0">
                        <mdb-input outline
                                class="sr-textarea" ref="dateClick" type="textarea" readonly
                                id="datepicker-trigger"
                                placeholder="" :rows="2"
                                :value="formatDates(dateOne)"
                        >
                            <img src="../assets/images/Calender.png" class="input-icon">
                        </mdb-input>

                    </div>

                    <div class="col-12 col-md-2 pl-md-0" v-if="dateRange==='range'">
                        <mdb-input outline
                                class="sr-textarea"  type="textarea"
                                    readonly @click="openDatepicker" ref="returnDate"
                                   id="datepicker-trigger"
                                   placeholder=""
                                   :value="formatDates(dateTwo)"
                        >
                            <img src="../assets/images/Calender.png" class="input-icon">
                        </mdb-input>

                    </div>

                    <div class="col-12 col-md-2 pl-md-0" @click="flightType = 'RT'" ref="rtDate" v-else>
                        <mdb-input outline
                                   class="sr-textarea"  type="textarea" value="Dönüş Tarihi        Gidiş Dönüş seçiniz..">
                            <img src="../assets/images/Calender.png" class="input-icon">
                        </mdb-input>

                    </div>
                    <input type="hidden" id="depar-date" name="fromdate" :value="formatDates(dateOne,'',2)">
                    <input  type="hidden" id="arrival-date" name="todate" :value="formatDates(dateTwo,'',2)" v-if="dateRange=='range'">

                    <div class="col-2 col-md-1 pl-md-0" style="max-width: 70px;">
                        <mdb-card class=""
                                  style="margin-top: 15px;
                                background-color: transparent;
                                color: white;
                                border: 1px solid #fff;
                                height: 38px;

                                box-shadow: none;">
                            <mdb-card-body class="p-1">
                                <mdb-dropdown style="min-width: 200px" multiLevel>
                                    <mdb-card-text class="airport-code text-white" slot="toggle">
                                        <img src="../assets/images/Man.png" />  <span style="font-size: 14px">+</span>
                                        <mdb-badge color="info" class="ml-md-2" style="position: absolute;
    top: -14px;
    font-size: 13px;">{{(parseInt(adultPerson) + parseInt(childPerson) + parseInt(babyPerson))}} </mdb-badge>
                                    </mdb-card-text>
                                    <mdb-dropdown-menu >
                                        <div class="px-3">
                                            <div class="row mb-2">
                                                <div class="col-4">
                                                    <label class="mt-2">Yetişkin</label>
                                                </div>
                                                <div class="col-8">
                                                    <number-input v-model="adultPerson" :min="1" :max="10" inline controls @click.stop></number-input>
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-4">
                                                    <label class="mt-2">Çocuk</label>
                                                </div>
                                                <div class="col-8">
                                                    <number-input v-model="childPerson"  :min="0" :max="10" inline controls @click.stop></number-input>
                                                </div>
                                            </div>
                                            <div class="row mb-2">
                                                <div class="col-4">
                                                    <label class="mt-2">Bebek</label>
                                                </div>
                                                <div class="col-8">
                                                    <number-input v-model="babyPerson"  :min="0" :max="10" inline controls @click.stop></number-input>
                                                </div>
                                            </div>
                                            <mdb-btn type="button" color="primary" class="btn-block">Tamam</mdb-btn>
                                        </div>
                                    </mdb-dropdown-menu>
                                </mdb-dropdown>
                            </mdb-card-body>
                        </mdb-card>
                        <input type="hidden" name="adult" v-model="adultPerson" />
                        <input type="hidden" name="child" v-model="childPerson" />
                        <input type="hidden" name="infant" v-model="babyPerson" />
                    </div>
                    <div class="col-9 col-md pl-md-0 pr-md-2">
                        <select class="browser-default custom-select" name="flight_class"
                                v-model="flightClass" inline controls @click.stop
                                style="background-color: transparent;color: white;margin-top: 15px;"
                        >
                            <option value="Economy">Ekonomi</option>
                            <option value="FirstClass">First Class</option>
                            <option value="Comfort">Comfort</option>
                            <option value="Business">Business</option>
                        </select>
                    </div>
                    <div class="col-12 col-md pl-md-0">
                        <mdb-btn color="info" class="m-0 mt-3 px-4 btn-mobile-block" style="height: 38px;
    line-height: 16px;">Bilet Bul</mdb-btn>
                    </div>
                </div>
            </form>
        </div>

</template>

<script>
    import { mdbContainer, mdbCol, mdbRow, mdbIcon, mdbTabs, mdbJumbotron, mdbView, mdbMask, mdbBtn, mdbTextarea, mdbInput, mdbCarousel, mdbCarouselItem,mdbCard, mdbCardImage, mdbCardBody, mdbCardTitle, mdbCardText, mdbCarouselCaption,mdbDropdown, mdbDropdownItem, mdbDropdownMenu, mdbDropdownToggle, mdbBadge } from 'mdbvue';
    import format from 'date-fns/format';
    import locale from "date-fns/locale/tr";
    import Autocomplete from '@trevoreyre/autocomplete-vue';
    import axios from "axios";
    export default {
        name: "findFlight",
        components: {
            mdbContainer,
            mdbCol,
            mdbRow,
            mdbIcon,
            mdbTabs,
            mdbJumbotron,
            mdbView,
            mdbMask,
            mdbBtn,
            mdbTextarea,
            mdbInput,
            mdbCarouselItem,
            mdbCard,
            mdbCardImage,
            mdbCardBody,
            mdbCardTitle,
            mdbCardText,
            mdbCarousel,
            mdbCarouselCaption,
            mdbBadge,
            Autocomplete,
            mdbDropdown, mdbDropdownItem, mdbDropdownMenu, mdbDropdownToggle,
        },
        data() {
            return {
                dateFormat: 'D MMMM YYYY',
                dateFormatDay:'dddd',
                dateFormatSql: 'YYYY-MM-DD',
                dateOne: '',
                dateTwo: '',
                adultPerson :1,
                childPerson:0,
                babyPerson:0,
                airports :[],
                fromCity : "Havaalanı veya Şehir",
                toCity:"Havaalanı veya Şehir",
                fromName:"",
                toName:"",
                fromString:"",
                fromAutoComplate : false,
                fromAirCode:"",
                fromCountry:"",
                fromIsCity:"",
                toIsCity:"",
                toString:"",
                toAutoComplate : false,
                toCountry:"",
                toAirCode:"",
                dateRange:"single",
                flightClass:"",
                flightType:"",
                if_direct_flight_only:""
            }
        },
        methods: {
            formatDates(dateOne, dateTwo,dateType) {
                let formattedDates = ''
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat, { locale }) +'\n'+format(dateOne, this.dateFormatDay, { locale })
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat, { locale })
                }
                if (dateType){
                    if (dateType == 1){
                        formattedDates = format(dateOne, this.dateFormatDay, { locale })
                    }else{
                        formattedDates = format(dateOne, this.dateFormatSql)
                    }
                }
                return formattedDates
            },
            callFunction: function () {
                var currentDate = new Date();
                var currentDateWithFormat = new Date().toJSON().slice(0,10);
                return currentDateWithFormat;
            },
            toFly: function(){
                if(this.toString.length>1){
                    this.axiosCall(this.toString);
                    this.toAutoComplate = true;
                }
                /*var countries=[];
                this.airports.map(el => {
                    countries.push(el.city_name + ", " + el.localized_country_name + " - " + el.name + "  (" + el.code + ")");
                    //countries.push(...el);
                    //return el.codes = el.codes.split('+')
                });*/

            },
            fromFly: function(){
                if(this.fromString.length>1){
                    this.axiosCall(this.fromString);
                    this.fromAutoComplate = true;
                }
                /*var countries=[];
                this.airports.map(el => {
                    countries.push(el.city_name + ", " + el.localized_country_name + " - " + el.name + "  (" + el.code + ")");
                    //countries.push(...el);
                    //return el.codes = el.codes.split('+')
                });*/

            },
            selectAir(str){

                if(str==="to"){
                    this.toAirCode = event.target.getAttribute('data-airport-code');
                    this.toName = event.target.getAttribute('data-airport-name');
                    if(event.target.getAttribute('data-airport-city')){
                        this.toCity = event.target.getAttribute('data-airport-city');
                    }
                    this.toString=event.target.firstChild.data;
                    this.toCountry = event.target.getAttribute('data-country');
                    this.toIsCity = event.target.getAttribute('data-iscity');
                    this.toAutoComplate = false;
                }else{
                    this.fromAirCode = event.target.getAttribute('data-airport-code');
                    this.fromName = event.target.getAttribute('data-airport-name');
                    if(event.target.getAttribute('data-airport-city')){
                        this.fromCity = event.target.getAttribute('data-airport-city') ;
                    }
                    this.fromString=event.target.firstChild.data;
                    this.fromCountry = event.target.getAttribute('data-country');
                    this.fromIsCity = event.target.getAttribute('data-iscity');
                    this.fromAutoComplate = false;

                }
            },
            params:function(){
                const urlParams = new URLSearchParams(window.location.search);
                if(urlParams.get('from')){
                    localStorage.fromAirCode = urlParams.get('from');
                    localStorage.fromCountry = urlParams.get('fromCountry');
                    localStorage.fromIsCity = urlParams.get('fromIsCity');
                    localStorage.fromCity = urlParams.get('fromCityName');
                    localStorage.fromName = urlParams.get('fromName');
                    localStorage.fromString = urlParams.get('fromName');
                    localStorage.toAirCode = urlParams.get('to');
                    localStorage.toCountry = urlParams.get('toCountry');
                    localStorage.toIsCity = urlParams.get('toIsCity');
                    localStorage.toCity = urlParams.get('toCityName');
                    localStorage.toName = urlParams.get('toName');
                    localStorage.toStrings = urlParams.get('toName');
                    localStorage.dateOne = urlParams.get('fromdate');
                    localStorage.dateTwo = urlParams.get('todate');
                    localStorage.adultPerson = urlParams.get('adult');
                    localStorage.childPerson = urlParams.get('child');
                    localStorage.babyPerson = urlParams.get('infant');
                    localStorage.flightType = urlParams.get('flight_type');
                    localStorage.flightClass = urlParams.get('flight_class');
                }
                if(localStorage.fromAirCode) {
                    this.fromAirCode = localStorage.fromAirCode;
                    this.fromCountry = localStorage.fromCountry;
                    this.fromIsCity = localStorage.fromIsCity;
                    this.fromCity = localStorage.fromCity;
                    this.fromName = localStorage.fromName;
                    this.fromString = localStorage.fromString;
                    this.toAirCode = localStorage.toAirCode;
                    this.toCountry = localStorage.toCountry;
                    this.toIsCity = localStorage.toIsCity;
                    this.toCity = localStorage.toCity;
                    this.toName = localStorage.toName;
                    this.toString = localStorage.toStrings;
                    this.dateOne = localStorage.dateOne;
                    this.dateTwo = localStorage.dateTwo;
                    this.adultPerson = localStorage.adultPerson;
                    this.childPerson = localStorage.childPerson;
                    this.babyPerson = localStorage.babyPerson;
                    this.flightType = localStorage.flightType;
                    this.flightClass = localStorage.flightClass;
                }
                let date = new Date();
                if(this.dateOne==""){
                    date.setDate(date.getDate() + 1);
                    this.dateOne = date;
                }
                if(this.dateRange == "range" && this.dateTwo == ""){
                    date.setDate(date.getDate() + 3);
                    this.dateTwo = date;
                    console.log(this.dateTwo);
                }
                if(this.flightClass==""){
                    this.flightClass = 'Economy';
                }
                if(this.flightType==""){
                    this.flightType = 'OW';
                }
                if(this.flightType === "RT"){
                    this.dateRange = "range";
                }

            },
            inputFocus(referer){
                if(referer == "frominput"){
                    this.$refs.frominput.focus();
                }
                if(referer == "toinput"){
                    this.$refs.toinput.focus()
                }

            },
            changeToRouth(){
                let frcity,fraircode,frname,frcountry,friscity,frstring;

                frcity = this.fromCity;
                fraircode = this.fromAirCode;
                frname = this.fromName;
                frcountry = this.fromCountry;
                friscity = this.fromIsCity;
                frstring = this.fromString;

                this.fromCity = this.toCity;
                this.fromAirCode = this.toAirCode;
                this.fromName = this.toName;
                this.fromCountry = this.toCountry;
                this.fromIsCity = this.toIsCity;
                this.fromString = this.toString;

                this.toCity=frcity;
                this.toAirCode=fraircode;
                this.toName=frname;
                this.toCountry=frcountry;
                this.toIsCity=friscity;
                this.toString=frstring;
            },
            selectFromText: function(event){
                event.target.setSelectionRange(0, this.fromString.length);
            },
            selectToText: function(event){
                event.target.setSelectionRange(0, this.toString.length);
            },
            openDatepicker:function(){
                this.$refs.dateClick.focus();
                this.$refs.dateClick.click();
                console.log("tıkladım");
            },
            /*search(input) {
                //console.log(this.airports);
                this.axiosCall();
                var countries=[];
                this.airports.map(el => {
                    countries.push(el.city_name + ", " + el.localized_country_name + " - " + el.name + "  (" + el.code + ")");
                    //countries.push(...el);
                    //return el.codes = el.codes.split('+')
                });
                //return newArr;
                /!**
                 * city_name,
                 * localized_country_name,
                 * name
                 * code
                 *!/
                if (input.length < 1) { return [] }
                return countries.filter(country => {
                    return country.toLowerCase()
                        .startsWith(input.toLowerCase())
                });
                /!*if (input.length < 1) { return [] }
                return this.airports.forEach(function(a,b){
                    console.log('bb'+b);
                    b.filter(airport => {
                        return airport.toLowerCase()
                            .startsWith(input.toLowerCase())
                    })
                });*!/
            },*/
            /*getResultValue(result) {
                return result.city_name
            },

            handleSubmit(result) {
                this.fromCity = result
            },*/
            axiosCall(inputString){
                axios.get("https://www.biletbul.com/backend/public/api/v1/flight/trip/autocomplete?term="+inputString,{
                    headers: {

                    }
                })
                    .then((response => this.airports = [...response.data.data]));
                //.then(response => this.airports=[...response.data]);
            }

        },
        watch:{
            flightType:function () {
                let date = new Date(this.dateOne);
                console.log(date);
                let self = this;
                if(this.flightType==="RT" && this.dateTwo === ""){
                    date.setDate(date.getDate() + 3);
                    this.dateTwo = date;
                    this.dateRange = "range";
                    if(this.$refs.rtDate){
                        setTimeout(function () {
                            self.openDatepicker();
                        },100);
                    }

                }
                if(this.flightType==="RT" && this.dateTwo !== ""){
                    this.dateRange = "range";
                }
            }
        },
        mounted() {
            this.params();
            this.callFunction();

        }

    }
</script>

<style scoped>

</style>
